import { ActivityClientV2 } from './v2';
import { ActivityClientV3 } from './v3';
var previousClientVersion;
export var createActivityClient = function createActivityClient(version, product, logger, baseUrl, configFetch) {
  if (previousClientVersion && previousClientVersion !== version && logger !== null && logger !== void 0 && logger.captureWarning) {
    logger.captureWarning("ActivityClient version has changed, is this intentional?");
  }
  previousClientVersion = version || 'v3';
  if (version === 'v2') {
    return new ActivityClientV2(product, baseUrl);
  }
  return new ActivityClientV3(product, baseUrl, logger, configFetch);
};